import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
    Modal,
    Button,
    Row,
    Col,
    Form,
} from "react-bootstrap";
import validate from "validate.js";
import {
    createOrUpdateTask,
    hideTaskValidationError,
    timeSheetTaskRedirectToList
    
} from "actions";
import { TimesheetCategoryDropdown } from "CommonDropdowns";

const schema = {
    name: {
        presence: { allowEmpty: false, message: '^Task name is required' },
    },
    timesheet_category_id: {
        presence: { allowEmpty: false, message: '^Category is required' },
    }
};

const AddUpdateTask = (props) => {
    const {
        show,
        onHide,
        isEdit = false,
        object_viewed_id,
    } = props;


    console.log('task_object_viewed_id',object_viewed_id)
    const dispatch = useDispatch();
    const timeSheetTaskState = useSelector((state) => state.timeSheetTaskState);
    const { taskRecord, validation_error, redirectToList } = timeSheetTaskState;

    const [formState, setFormState] = useState({
        isValid: false,
        values: {},
        touched: {},
        errors: {}
    });
    const [categoryValue, setCategoryValue] = useState(null);

    useEffect(() => {
        if (isEdit && taskRecord) {
            const values = {
                id: taskRecord.id,
                name: taskRecord.name,
                timesheet_category_id: taskRecord.timesheet_category_id,
            };
            setFormState(formState => ({
                ...formState,
                values
            }));
            if(taskRecord.category){
                setCategoryValue({label: taskRecord.category.name, value: taskRecord.category.id});
            }
            if(taskRecord.description){
                setFormState(formState => ({
                    ...formState,
                    values: {
                        ...formState.values,
                        description: taskRecord.description,
                    }
                }));
            }
        }
    }, [taskRecord, isEdit]);

    useEffect(() => {
        if (validation_error) {
            setFormState((formState) => ({
                ...formState,
                isValid: false,
                errors: validation_error || {},
            }));
        }
    }, [validation_error]);

    useEffect(() => {
        const errors = validate(formState.values, schema);
        setFormState(formState => ({
            ...formState,
            isValid: !errors,
            errors: errors || {}
        }));
    }, [formState.values]);

    useEffect(() => {
        if (redirectToList) {
            onHide();
        }
    }, [redirectToList]);

    const handleChange = (event) => {
        event.persist();
        setFormState((formState) => ({
            ...formState,
            values: {
                ...formState.values,
                [event.target.name]: event.target.value,
            },
            touched: {
                ...formState.touched,
                [event.target.name]: true,
            },
        }));
        dispatch(hideTaskValidationError(event.target.name));
    };

    const handleCategoryChange = (selected) => {
        setCategoryValue(selected);
        setFormState((formState) => ({
            ...formState,
            values: {
                ...formState.values,
                timesheet_category_id: selected ? selected.value : '',
            },
            touched: {
                ...formState.touched,
                timesheet_category_id: true,
            },
        }));
        dispatch(hideTaskValidationError('timesheet_category_id'));
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        const method = formState.values.id ? "PUT" : "POST";
        dispatch(createOrUpdateTask(formState.values, method, object_viewed_id));
    };

    const hasError = (field) =>
        formState.touched[field] && formState.errors[field] ? true : false;

    const onModelClose = () => {
        onHide();
        
        setFormState({
            isValid: false,
            values: {},
            touched: {},
            errors: {}
        });

        setCategoryValue(null);

        dispatch(timeSheetTaskRedirectToList()); 
    }

    return (
        <Modal
            show={show}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            onHide={onModelClose}
            className="add-new-program"
        >
            <div className="p-2">
                <Modal.Header className="p-2" closeButton>
                    <Modal.Title>
                        <h5 className="font-20 font-weight-bold heading-color">{isEdit ? "Update" : "Add"} Task</h5>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmit}>
                        
                        <Form.Group className="mb-2">
                            <Form.Label className="font-13 font-weight-400 page-heading">
                                Name
                            </Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Enter name"
                                name='name'
                                onChange={handleChange}
                                value={formState.values.name || ''}
                                className={`input-field ${hasError('name') ? 'is-invalid' : ''}`}
                            />
                            {hasError('name') && (
                                <Form.Control.Feedback type="invalid">
                                    {formState.errors.name[0]}
                                </Form.Control.Feedback>
                            )}
                        </Form.Group>
                        <TimesheetCategoryDropdown
                            categoryValue={categoryValue}
                            categoryOnChange={handleCategoryChange}
                            setCategoryValue={setCategoryValue}
                            isMulti={false}
                            error={hasError('timesheet_category_id') ? formState.errors.timesheet_category_id[0] : ''}
                        />
                        <Form.Group className="mb-3">
                            <Form.Label className="label-input">Description</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={3}
                                style={{
                                borderRadius: "10px",
                                border: "1px solid rgb(206, 212, 218)",
                                padding: "4px 12px",
                                fontSize: "12px",
                                fontWeight: 400,
                                color: "rgb(97, 121, 115)"
                                }}
                                onChange={handleChange}
                                value={formState.values.description || ''}
                                name='description'
                                placeholder="Type here"
                            />
                            {hasError('description') && (
                                <Form.Control.Feedback type="invalid">
                                    {formState.errors.description[0]}
                                </Form.Control.Feedback>
                            )}
                        </Form.Group>
                        <Row className="mt-3">
                            <Col lg={6}>
                            <button className="c-b-btn w-100" onClick={onModelClose}>
                                Cancel
                            </button>
                            </Col>
                            <Col lg={6}>
                            <button 
                                onClick={handleSubmit}
                                disabled={!formState.isValid} 
                                className="n-u-btn w-100" 
                            >
                                {isEdit ? "Update" : "Add"}
                            </button>
                            </Col>
                        </Row>
                            
                    </Form>
                </Modal.Body>
            </div>
        </Modal>
    );
};

export default AddUpdateTask;
